import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "session-wrapper" }

import { ref, onMounted, onUnmounted, nextTick } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'session-wrapper',
  setup(__props, { expose: __expose }) {

const latestProgress = ref<number | null>(null);
const show = ref({ show: true });
const resizeTimeout = ref<any>(null);
const lastWidthInPixels = ref(0);

function isMobileChrome(): boolean {
  const ua = navigator.userAgent;
  const isChrome = /Chrome/i.test(ua);
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  return isChrome && isMobile;
}

function onProgress(newProgress: number | null): void {
  latestProgress.value = newProgress;
}

function handleResize() {
  // Reset the session, maintaining the latest progress (if there was any)
  nextTick(() => {
    show.value.show = false;
    setTimeout(() => {
      nextTick(() => {
        show.value.show = true;
      });
    }, 0);
  });
}

function onResize() {
  // Only reset when the width changes, to prevent browser bar changes triggering a reset
  if (window.innerWidth !== lastWidthInPixels.value) {
    lastWidthInPixels.value = window.innerWidth;
    show.value.show = false;

    if (resizeTimeout.value) {
      clearTimeout(resizeTimeout.value);
    }
    resizeTimeout.value = setTimeout(() => {
      handleResize();
    }, 400);
  }
}

onMounted(() => {
  window.addEventListener("resize", onResize);
  lastWidthInPixels.value = window.innerWidth;

  if (isMobileChrome()) {
    const viewport = document.querySelector("meta[name=viewport]");
    viewport!.setAttribute(
      "content",
      `height=${document.documentElement.clientHeight}, width=device-width, initial-scale=1.0`,
    );
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);

  // Reset viewport on destruction;
  if (isMobileChrome()) {
    const viewport = document.querySelector("meta[name=viewport]");
    viewport!.setAttribute("content", "width=device-width, initial-scale=1.0");
  }
});

__expose({
  onProgress,
  latestProgress,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (show.value.show)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true)
  ]))
}
}

})